import React, { useEffect, useState } from "react";
import axios from "../axios";
import { useNavigate, useSearchParams } from "react-router-dom";

const VerifyAccountLogin = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const encryptedPhone = searchParams.get("code");

    if (!encryptedPhone) {
      setError("Missing encrypted phone code");
      setLoading(false);
      return;
    }

    // Call the API to login with encrypted phone
    axios
      .post(`v1/login-encrypted-phone`, {
        encryptedPhone: encryptedPhone,
      })
      .then((data) => {
        if (data.data?.is_success) {
          // Store JWT token if provided
          if (data.data.data?.token) {
            localStorage.setItem("homeshiksha-tutor-jwt", JSON.stringify(data.data.data.token));
          }
          // Store basic user details if provided
          if (data.data.data?.user) {
            const userData = data.data.data.user;
            localStorage.setItem(
              "userDetails",
              JSON.stringify({
                id: userData.id,
                name: userData.first_name,
                l_name: userData.last_name,
                email: userData.email,
                phone: userData.phone,
                user_type: userData.user_type,
              }),
            );
          }
          // Redirect to verify-account page
          navigate("/verify-account");
          window.location.reload();
        } else {
          setError(data.data?.error?.msg || "Login failed");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Login error:", err);
        setError(err.response?.data?.error?.msg || "Failed to login. Please try again.");
        setLoading(false);
      });
  }, [searchParams, navigate]);

  if (loading) {
    return (
      <main
        className="main"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <img src="./book-loader.gif" alt="Loading..." />
      </main>
    );
  }

  if (error) {
    return (
      <main
        className="main"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
          gap: "20px",
        }}
      >
        <div style={{ color: "red", fontSize: "18px", fontWeight: "600" }}>{error}</div>
        <button
          type="button"
          onClick={() => navigate("/")}
          style={{
            padding: "10px 20px",
            backgroundColor: "#2B93A5",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Go to Login
        </button>
      </main>
    );
  }

  return null;
};

export default VerifyAccountLogin;
